// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.address-selector .address-card {
  border: 2px solid #e9ecef;
  border-radius: 12px;
  transition: all 0.2s ease-in-out;
  background-color: #fff;
}

.address-selector .address-card:hover {
  border-color: #6c757d;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.address-selector .address-card.selected {
  border-color: #0d6efd;
  background-color: #f8f9ff;
  box-shadow: 0 4px 12px rgba(13, 110, 253, 0.15);
}

.address-selector .address-card .address-radio .form-check-input {
  width: 20px;
  height: 20px;
  margin-top: 0;
  cursor: pointer;
}

.address-selector .address-card .address-name {
  font-size: 1rem;
  color: #ffff;
}

.address-selector .address-card .address-content p {
  line-height: 1.4;
}

.address-selector .address-card .address-check {
  flex-shrink: 0;
}

.address-selector .cursor-pointer {
  cursor: pointer;
}

.address-selector h5 {
  color: #495057;
  font-weight: 600;
}

.address-selector h5 i {
  color: #6c757d;
}
`, "",{"version":3,"sources":["webpack://./src/components/eCommerce/CartStepper/AddressSelector.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".address-selector .address-card {\n  border: 2px solid #e9ecef;\n  border-radius: 12px;\n  transition: all 0.2s ease-in-out;\n  background-color: #fff;\n}\n\n.address-selector .address-card:hover {\n  border-color: #6c757d;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.address-selector .address-card.selected {\n  border-color: #0d6efd;\n  background-color: #f8f9ff;\n  box-shadow: 0 4px 12px rgba(13, 110, 253, 0.15);\n}\n\n.address-selector .address-card .address-radio .form-check-input {\n  width: 20px;\n  height: 20px;\n  margin-top: 0;\n  cursor: pointer;\n}\n\n.address-selector .address-card .address-name {\n  font-size: 1rem;\n  color: #ffff;\n}\n\n.address-selector .address-card .address-content p {\n  line-height: 1.4;\n}\n\n.address-selector .address-card .address-check {\n  flex-shrink: 0;\n}\n\n.address-selector .cursor-pointer {\n  cursor: pointer;\n}\n\n.address-selector h5 {\n  color: #495057;\n  font-weight: 600;\n}\n\n.address-selector h5 i {\n  color: #6c757d;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
